import React from "react";

const Medicine = ({ size = 50, color }: any) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 179.64 191.29"
      width={size}
      height={size}
      fill={color}
    >
      <path
        d="M73,29.71h71.36a2.13,2.13,0,0,0,.47.29c5.8,1.76,8.75,5.64,8.78,11.66,0,5.35.05,10.71,0,16.06a11,11,0,0,1-6.33,10.41,1.86,1.86,0,0,0-1.15,2c0,2.55-.06,5.11.06,7.66a5.14,5.14,0,0,0,.89,2.69c5.63,7.61,11.28,15.19,17,22.71a21.27,21.27,0,0,1,4.48,13.52c-.06,9.59,0,19.17,0,28.76v2.22c.89-.46,1.49-.75,2.07-1.08,4.37-2.52,8.72-5,13.09-7.55a29,29,0,0,1,20.7-3.44c12.8,2.63,21.75,12.18,23.86,25.3,1.87,11.59-4.21,23.83-15,30.06-10,5.77-19.84,11.66-29.91,17.22C174.78,213,166.88,219.4,156.71,221H150a5.65,5.65,0,0,0-1-.34,29.3,29.3,0,0,1-20.23-12.75,3,3,0,0,0-2.84-1.51q-28.56.06-57.13,0C57,206.42,49,198.53,49,186.8c0-23.53,0-47.05,0-70.58a20.4,20.4,0,0,1,4.29-12.82c4.37-5.73,8.36-11.81,13.1-17.22,4.15-4.75,5.87-9.82,5.09-16a2.26,2.26,0,0,0-1.3-2.12c-3.83-2-6.08-5.15-6.17-9.52-.11-6-.09-12.07,0-18.1a10.54,10.54,0,0,1,5.64-9.28A30,30,0,0,1,73,29.71ZM56.6,176.38a3.87,3.87,0,0,0,.59.13q34.44,0,68.9,0a2.4,2.4,0,0,0,1.73-1,31.54,31.54,0,0,1,11.57-10.88c6.75-3.84,13.45-7.79,20.22-11.61a2.62,2.62,0,0,0,1.51-2.64c-.06-9,0-17.92,0-26.88v-1.75H56.6ZM108.66,61.84h32.88c3.19,0,4.6-1.36,4.62-4.51q0-7.84,0-15.69c0-3.06-1.44-4.45-4.49-4.45H75.91c-3.12,0-4.45,1.31-4.46,4.42,0,5.16,0,10.33,0,15.5,0,3.5,1.24,4.73,4.72,4.73Zm82.73,133.32c7.1-4.23,14.41-7.93,21-12.64,9.47-6.78,11.4-20.16,5-29.88a22.41,22.41,0,0,0-29.3-7.43c-2.3,1.24-4.54,2.59-6.8,3.9l-12.37,7.14C176.41,169.22,183.83,182.06,191.39,195.16Z"
        transform="translate(-49 -29.71)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M56.6,176.38V121.75H161.09v1.75c0,9,0,17.92,0,26.88a2.62,2.62,0,0,1-1.51,2.64c-6.77,3.82-13.47,7.77-20.22,11.61a31.54,31.54,0,0,0-11.57,10.88,2.4,2.4,0,0,1-1.73,1q-34.45.08-68.9,0A3.87,3.87,0,0,1,56.6,176.38Zm56-29.74v-2.06c0-3.05.07-6.1,0-9.14a3.72,3.72,0,0,0-3.85-3.74,3.66,3.66,0,0,0-3.6,3.76c-.07,1.74,0,3.48,0,5.22v6c-3.86,0-7.41,0-11,0a3.75,3.75,0,1,0,0,7.48c3.59,0,7.17,0,10.91,0,0,3.85,0,7.45,0,11a3.67,3.67,0,0,0,3.67,3.89,3.79,3.79,0,0,0,3.78-3.63,20,20,0,0,0,0-2.05v-9.25h7.27c5.76,0,7.59-.89,7.64-3.71s-1.85-3.79-7.54-3.79Z"
        transform="translate(-49 -29.71)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M108.66,61.84H76.16c-3.48,0-4.71-1.23-4.72-4.73,0-5.17,0-10.34,0-15.5,0-3.11,1.34-4.42,4.46-4.42h65.76c3.05,0,4.47,1.39,4.49,4.45q0,7.84,0,15.69c0,3.15-1.43,4.51-4.62,4.51Z"
        transform="translate(-49 -29.71)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M191.39,195.16c-7.56-13.1-15-25.94-22.46-38.91l12.37-7.14c2.26-1.31,4.5-2.66,6.8-3.9a22.41,22.41,0,0,1,29.3,7.43c6.38,9.72,4.45,23.1-5,29.88C205.8,187.23,198.49,190.93,191.39,195.16Z"
        transform="translate(-49 -29.71)"
      />
      <path
        d="M112.56,146.64h7.37c5.69,0,7.59,1,7.54,3.79s-1.88,3.71-7.64,3.71h-7.27v9.25a20,20,0,0,1,0,2.05,3.79,3.79,0,0,1-3.78,3.63,3.67,3.67,0,0,1-3.67-3.89c-.06-3.59,0-7.19,0-11-3.74,0-7.32,0-10.91,0a3.75,3.75,0,1,1,0-7.48c3.54,0,7.09,0,11,0v-6c0-1.74,0-3.48,0-5.22a3.66,3.66,0,0,1,3.6-3.76,3.72,3.72,0,0,1,3.85,3.74c.11,3,0,6.09,0,9.14Z"
        transform="translate(-49 -29.71)"
      />
    </svg>
  );
};

export default Medicine;
